import { makeVar } from "@apollo/client";
import type { Common } from "@beautypie/segment/Common";

const context = {};

export const pageContextVar = makeVar<Common["context"]>(context);
